import { atom, atomFamily } from "recoil";

import { RydeUiUnit } from "../../models";

export const dropdownsIsFetchingAtom = atom<boolean>({
  key: "dropdownsFetchingAtom",
  default: false,
});

export const apiDataFetchingAtom = atom<boolean>({
  key: "apiDataFetchingAtom",
  default: false,
});

export const isSessionGateLoaderAtom = atom<boolean>({
  key: "isSessionGateLoaderAtom",
  default: false,
});

export const isFullscreenOverlayVisibleAtom = atom<boolean>({
  key: "isFullscreenOverlayVisibleAtom",
  default: false,
});

export const loadingEditFormContentAtomFamily = atomFamily<boolean, RydeUiUnit>(
  {
    key: "editFormContentLoadingAtomFamily",
    default: () => false,
  },
);

export const tableGridFetchingAtomFamily = atomFamily<boolean, RydeUiUnit>({
  key: "tableGridFetchingAtomFamily",
  default: () => false,
});

export const viewChangesApplyingAtom = atom<boolean>({
  key: "viewChangesApplyingAtom",
  default: false,
});

export const customLoaderAtom = atom<boolean>({
  key: "customLoaderAtom",
  default: false,
});

export const rebuildRouteLoadingAtom = atom<boolean>({
  key: "rebuildRouteLoadingAtom",
  default: false,
});

export const rideRebuildLoadingAtom = atom<boolean>({
  key: "rideRebuildLoadingAtom",
  default: false,
});
